import { Container, Typography, Box, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import { APP_PATH } from "../../constant";

const GeneralRules = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          Règle n°1 : Les cours se déroulent sur Zoom.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          Règle n°2 : L'heure est de 6 euros en privé.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          Règle n°3 : Vous avez la possibilité d'etudier avec un binôme mais a
          vous de créer votre binôme.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          Règle n°4 : Le prix pour un binôme est fixé à 5 euros de l'heure soit
          2.50 euros de l'heure par élève. Les groupes dans notre institut ne
          dépassent pas 2 pour ne pas perdre la concentration des élèves.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          Règle n°5 : L'élève s'engage a payer ces cours avant d'avoir pris ces
          cours soit dans la période du 1 au 5 du mois.
          <br />
          <br />
          <strong>
            Un message sera envoyé à l'élève le 5 du mois si ce dernier n'a pas
            payé ses cours.
          </strong>
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          Règle n°6 : Si l'élève s'absente l'heure ne lui sera pas remboursé
          mais si le professeur s'absente il devra rattraper l'heure si cela est
          impossible le prix du cours sera déduit du prochain paiement.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          Règle n°7 : Si l'élève est inactif nous considérerons cela comme une
          désinscription
          <br />
          <br />
          <strong>
            L'élève est considéré comme inactif lorsqu'il ne se présente pas à
            ses cours et qu'il ne paye pas ses cours.
          </strong>
        </Typography>
      </Box>
      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          Règle n°8 : En cas de retard du professeur l'élève attendra 15
          minutes, ce délai passé l'élève considérera que son professeur est
          absent, le cours sera donc rattrapé et si cela n'est pas possible il
          sera déduit de la facture du prochain mois.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          Règle n°9 : Pour assurer une réelle progression de l'élève, il devra
          étudier 3 heures minimum par semaine.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="body1" gutterBottom>
          <strong>DEMANDE DE REMBOURSEMENT</strong> : Vous avez la possibilité
          de demander un remboursement si vous n’êtes pas satisfait de votre
          premièr mois après inscription en cliquant{" "}
          <Link to={APP_PATH.CONTACT}>ici</Link>.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />
    </Container>
  );
};

export default GeneralRules;
